export class Constants {
  static COUNTRY_CODE = '356';
  static BANK_COUNTRY_CODE = 'MT';
}
